import React from 'react';

type Props = {
  variant?: 'powered' | 'built';
  className?: string;
};

export default function FabricBadge({ variant = 'powered', className }: Props) {
  const text = variant === 'built' ? 'Built on Arkodomo Fabric' : 'Powered by Arkodomo Fabric';
  return (
    <span className={["fabric-badge", "badge", "rounded-pill", className].filter(Boolean).join(' ')} aria-label={text}>
      {text}
    </span>
  );
}

